Object.defineProperty (module.exports, "__esModule", { value: true }),
module.exports.DateTimeNameContext = module.exports.default = {
	FORMAT: "format",
	STANDALONE: "standalone",
};